import ReactDOM from 'react-dom';

// React 19 removed findDOMNode. semantic-ui-react calls it internally via
// @fluentui/react-component-ref. Polyfill it here until semantic-ui-react
// components are replaced with MUI equivalents.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(ReactDOM as any).findDOMNode = (instance: any): Element | null => {
  if (instance == null) {
    return null;
  }

  if (instance instanceof Element) {
    return instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fiber = (instance as any)._reactInternals ?? (instance as any)._reactInternalFiber;
  if (fiber == null) {
    return null;
  }

  let node = fiber;
  while (node) {
    if (node.stateNode instanceof Element) {
      return node.stateNode;
    }
    node = node.child;
  }
  return null;
};
